export default __webpack_public_path__ + "static/media/01.40a4639f.jpg";